/**
 * constants.js
 *
 * Central configuration file for application constants
 */

// Theme
export const THEME_STORAGE_KEY = 'theme_preference'

// Session
export const SESSION_TIMEOUT_DAYS = 14

// Support user configuration
export const SUPPORT_EMAIL = 'support@syftai.com'
export const SUPPORT_TENANT_ID = 'Syft Support'

// AI Email Preferences Limits
export const MAX_AI_EMAIL_RULES = 10
export const MAX_AI_EMAIL_EXAMPLES = 3

//styles
export const integrationStyles = {
  // these will be manually edited to avoid having to call the listIntegrations api
  apolloio: {
    type: 'apolloio',
    name: 'Apollo.io',
    brandColor: '#FECF40',
    icon: 'https://cdn.useparagon.com/latest/dashboard/public/integrations/apolloio.svg'
  },
  outreach: {
    type: 'outreach',
    name: 'Outreach',
    brandColor: '#5951FF',
    icon: 'https://cdn.useparagon.com/latest/dashboard/public/integrations/outreach.svg'
  },
  hubspot: {
    type: 'hubspot',
    name: 'Hubspot',
    brandColor: '#F67600',
    icon: 'https://cdn.useparagon.com/latest/dashboard/public/integrations/hubspot.svg'
  },
  salesloft: {
    type: 'salesloft',
    name: 'Salesloft',
    brandColor: '#064B2E',
    icon: 'https://cdn.useparagon.com/latest/dashboard/public/integrations/salesloft.svg'
  }
}

export const FLOW_ALLOW_EDIT_STATUS = [
  'flow_ready_for_review',
  'flow_completed',
  'flow_needs_review',
  'flow_failed',
  'destination_completed',
  'destination_failed'
]

export const FLOW_COMPLETED_STATES = ['flow_completed', 'destination_completed']

export const FLOW_IN_PROGRESS_STATES = ['flow_in_progress', 'flow_not_started']

export const FLOW_BLOCKED_DELETE_STATES = ['flow_in_progress']

export const URLS = {
  support: 'https://syft.notion.site/support',
  changeLog: 'https://syft.notion.site/change-log',
  actions: 'https://syft.notion.site/actions',
  actionsRequestForm: 'https://syft.notion.site/198de3d002a580559105da84608114c7',
  configuringSequenceVariables: 'https://syft.notion.site/configuring-value-message-sequence'
}
